import candidateService from '../../../api/candidate.service'
import pfServices from '../../../api/progressflow.service'

const actions = {
  getDocs: async context => {
    try {
      let docs = await pfServices.getDocs()
      context.commit('updateDocs', docs)
    } catch (e) {
      throw e.response
    }
  },
  updateDoc: async (context, data) => {
    try {
      await pfServices.updateDoc(data)
    } catch (e) {
      throw e
    }
  },
  reorderDoc: async (context, data) => {
    try {
      await pfServices.reorderDoc(data)
    } catch (e) {
      throw e.response
    }
  },
  createDoc: async (context, data) => {
    try {
      await pfServices.createDoc(data)
    } catch (e) {
      throw e.response
    }
  },
  uploadDocFile: async (context, data) => {
    try {
      await pfServices.uploadFile(data)
    } catch (e) {
      throw e.response
    }
  },
  getCandidatePfSection: async context => {
    try {
      let details = await candidateService.fetchCandidateDetails()
      context.commit('updatePfDocsSection', details[0])
    } catch (e) {
      throw e.response
    }
  },
  getRecruiterPfSection: async (context, data) => {
    try {
      let details = await candidateService.fetchCandidateDetailsById(undefined, data)
      context.commit('updatePfDocsSection', {
        ...details[0],
        CandidateProgressFlow: { ...details[0].CandidateProgressFlow },
      })
    } catch (e) {
      console.log('e: ', e)
      throw e.response
    }
  },
  getPfCandidatesActivities: async context => {
    try {
      let details = await pfServices.getNewStatusCandidate({ count: 200 })
      let results = details.SearchedResult || []
      let newStatus = results.filter(canActivity => canActivity.newFlag === true)
      console.log('newStatus.length: ', newStatus.length)
      context.commit('updateActivityCount', newStatus.length)
      console.log('candidates PF : ', details)
    } catch (e) {
      console.log('e: ', e)
      throw e.response
    }
  },
  getNewStatusCandidate: async (context, data) => {
    try {
      let details = await pfServices.getNewStatusCandidate(data)
      let pageCount = details.TotalCount[0]?.count
      context.commit('updatePfCandidates', details)
      context.commit('updatePageCount', pageCount ? Math.ceil(pageCount / data.count) : 1)
    } catch (e) {
      console.log('e: ', e)
      throw e.response
    }
  },
  markSeen: async (context, data) => {
    try {
      await pfServices.markSeen(data)
    } catch (e) {
      throw e.response
    }
  },
  sendFiles: async (context, data) => {
    try {
      await pfServices.sendFiles(data)
    } catch (e) {
      throw e.response
    }
  },
  deleteDoc: async (context, data) => {
    try {
      await pfServices.deleteDoc(data)
    } catch (e) {
      throw e.response
    }
  },
  updateStatus: async (context, data) => {
    try {
      await pfServices.updateStatus(data)
    } catch (e) {
      throw e.response
    }
  },
}

export default actions
